<template>
    <Head>
        <title>Test page</title>
    </Head>

    <authenticated-layout :notifications="notifications" >
        <div class="bg-white">
            <h1 class="text-lg">Test page</h1>
            <p>success: <strong>{{ success }}</strong></p>
            <p>result:</p>
            <pre class="text-xs -bg-gray-600">{{ result }}</pre>
        </div>
    </authenticated-layout>
</template>

<script>

import {Head, Link} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
    },
    props: {
        success: Boolean,
        result: Object,
        notifications: Array,
    },

};
</script>
